export default "__VITE_ASSET__CLy$wMyf__"